import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Careers.css';
import logo from '../assets/logo.png';

const Careers = () => {
    const navigate = useNavigate();

    return (
        <div className="careers-container">
            <nav className="careers-nav">
                <div className="nav-logo" onClick={() => navigate('/')}>
                    <img src={logo} alt="Top Tier Processing" />
                </div>
                <div className="nav-links">
                    <button className="nav-link-btn" onClick={() => navigate('/why-us')}>Why Top Tier?</button>
                    <button className="nav-link-btn" onClick={() => navigate('/app')}>Client Login</button>
                </div>
            </nav>

            <header className="careers-hero">
                <div className="hero-content">
                    <h1>Grow With Us</h1>
                    <p className="hero-subtitle">
                        Join a team that values hard work, positivity, and continuous growth.
                        We invest heavily in our people because we believe that when you grow, we grow.
                    </p>
                </div>
            </header>

            <section className="careers-section pillars-section">
                <h2>Our Core Pillars</h2>
                <div className="pillars-grid">
                    <div className="pillar-card">
                        <h3>Hard Work</h3>
                        <p>We show up, we grind, and we get things done correctly and efficiently.</p>
                    </div>
                    <div className="pillar-card">
                        <h3>Positive Attitude</h3>
                        <p>Challenges arise, but we face them with a smile and a solution-oriented mindset.</p>
                    </div>
                    <div className="pillar-card">
                        <h3>Desire to Learn</h3>
                        <p>The mortgage industry evolves daily. We stay curious and never stop learning.</p>
                    </div>
                    <div className="pillar-card">
                        <h3>Desire to Improve</h3>
                        <p>Good enough isn't enough. We constantly strive to be better than yesterday.</p>
                    </div>
                </div>
            </section>

            <section className="careers-section benefits-section">
                <div className="benefits-content">
                    <h2>Why Join Top Tier?</h2>

                    <div className="benefits-list">
                        <div className="benefit-item">
                            <h3>💰 401k + 3% Match</h3>
                            <p>We support your future with a generous 3% employer match on your 401k.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>🏖️ Paid Time Off</h3>
                            <p>Work-life balance matters. Take time to recharge with our PTO policy.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>📈 Room for Growth</h3>
                            <p>We promote from within. There is a clear path for advancement on our team.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>🏡 Hybrid/Remote Opportunity</h3>
                            <p>We are big on training. After completing our comprehensive training program, hybrid and remote opportunities are available.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="careers-cta">
                <h2>Ready to Apply?</h2>
                <p>If you align with our pillars and want to build a career in mortgage operations, we'd love to hear from you.</p>
                <a href="mailto:info@toptiermp.com" className="apply-btn">
                    Apply Now
                </a>
            </section>

            <footer className="homepage-footer">
                <div className="footer-content">
                    <p>Contact Us: <a href="mailto:info@toptiermp.com">info@toptiermp.com</a></p>
                    <p className="footer-nmls">NMLS #2256200 | Currently licensed in FL</p>
                    <p>&copy; {new Date().getFullYear()} Top Tier Mortgage Processing. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Careers;
